export default __webpack_public_path__ + "static/media/ShoppyCommerceERP.e00d7ef0.svg";